import React from 'react';
import Icon from '@components/ui/icon';

const CloseIcon: React.FunctionComponent = () => <Icon name="times" />;
const SuccessIcon: React.FunctionComponent = () => <Icon name="check-circle" />;
const FailureIcon: React.FunctionComponent = () => <Icon name="times-circle" />;
const WarningIcon: React.FunctionComponent = () => <Icon name="warning-circle" />;

export { CloseIcon, SuccessIcon, FailureIcon, WarningIcon };
